import { computed, inject, Injectable, signal } from '@angular/core';
import { CartService } from '../../shared/services/cart.service';
import { GetCartResponse } from '../../shared/interfaces/get-cart-response.interface';
import { Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CartDataService {
  private cartService = inject(CartService);

  private _cartData = signal<GetCartResponse | null>(null);
  private _cartCounter = signal(0);
  private _hasCartArticles = signal(false);

  cartData = computed(() => this._cartData());
  cartCounter = computed(() => this._cartCounter());
  hasCartArticles = computed(() => this._hasCartArticles());

  constructor() {
    this.getCart();
  }

  addCart(detailCatalogId: string, quantity = 1) {
    this.cartService.addCart(detailCatalogId, quantity).subscribe({
      next: (isSuccess) => {
        if (isSuccess) {
          this.getCart();
        }
      },
    });
  }

  getCart(): void {
    this.cartService
      .getCart()
      .pipe(
        tap(({ items }) => {
          this._cartCounter.set(items.length);
          this._hasCartArticles.set(items.length > 0);
        })
      )
      .subscribe({
        next: (response) => this._cartData.set(response),
      });
  }

  addCartRecomendation(detailCatalogId: string, quantity = 1) : Observable<boolean>  {
    return this.cartService.addCartRecomedation(detailCatalogId, quantity);
  }
}
